<template>
  <NuxtLink
    class="no-underline px-xs py-2xs bg-white block"
    activeClass="font-bold [&_#dbc-icon-chevron-right]:text-primary"
    :to="route"
  >
    <Tab as="div" :value="value" v-bind="tabPassThrough">
      <DbcSvg :name="icon" class="self-center pr-xs min-w-[25px] box-content" />
      <span class="grow">{{ title }}</span>
      <span class="font-normal text-info-medium" v-if="subtitle">{{
        subtitle
      }}</span>
      <DbcSvg
        id="dbc-icon-chevron-right"
        name="dbc-icon-chevron-right"
        class="text-light min-w-[25px]"
      />
    </Tab>
  </NuxtLink>
</template>

<script setup lang="ts">
import Tab from 'primevue/tab'

defineProps<{
  title: string
  subtitle?: string
  icon: string
  route: string
  value: string
}>()

const tabPassThrough = {
  pt: {
    root: {
      class: 'border-none text-dark bg-white flex w-full text-start',
    },
  },
}
</script>
